import { useRuntimeConfig } from '#imports'
import { onMounted, ref, watchEffect } from 'vue'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { buildMilitaryDiscountUrl } from './MilitaryDiscountCTA.utils'

export function useMilitaryDiscountUrl() {
  const url = ref<ReturnType<typeof buildMilitaryDiscountUrl>>()
  const error = ref()

  const { isUserAuthenticated, user } = useUserStore()
  const logger = useLogger()
  const locale = useI18nLocale()

  const { SHEER_ID_MILITARY_DISCOUNT_URL } = useRuntimeConfig().public

  onMounted(() => {
    watchEffect(() => {
      try {
        url.value = buildMilitaryDiscountUrl({
          authenticated: isUserAuthenticated.value,
          baseSheerIdUrl: SHEER_ID_MILITARY_DISCOUNT_URL,
          bmUserId: user.value.bmUserId,
          locale,
        })
      } catch (err) {
        logger.error('[CONTENT] error when building military discount url', {
          error: err as Error,
          owners: ['bot-squad-lifecycle-front'],
        })
        error.value = err
      }
    })
  })

  return { url, error }
}
